import React from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { useTranslations } from 'js/components/common/I18n';
import style from './index.scss';

export const rankStyles = {
    1: style.gold,
    2: style.silver,
    3: style.bronze
};

export const rankFonts = {
    2: style.twoDigits,
    3: style.threeDigits,
    4: style.fourDigits,
    5: style.fiveDigits
};

export const Row = ({
                        rank,
                        name,
                        nickName,
                        score,
                        isMarkRank,
                        scoreStyle,
                        isMe,
                        isNoPrize,
                        addDivider,
                        prizeDescription,
                        remainingEventCount,
                        status
                    }) => (
    <>
        {addDivider && <div className={style.divider} />}
        <div
            className={`${style.row} ${isMe && status !== 'PENDING_REVIEW' ? style.isMe : ''} ${prizeDescription ? '' : style.noPrizeCol} ${typeof remainingEventCount != 'undefined' && !prizeDescription ? style.hasEventCol : ''}`}>
            <div className={style.col}>
                <div className={`${style.rank} ${isMarkRank && rankStyles[rank] || ''}`}>
                    <div className={`${style.rankText} ${rankFonts[rank.toString().length] || ''}`}>{rank}</div>
                </div>
            </div>
            <div className={style.col}>
                <div className={style.name}>{nickName || name}</div>
            </div>
            {typeof remainingEventCount != 'undefined' && !prizeDescription &&
            <div className={style.col}>
                <div className={`${style.event}`}>
                    {remainingEventCount}
                </div>
            </div>
            }
            <div className={style.col}>
                <div className={`${style.score} ${style[scoreStyle]}`}>{score}</div>
            </div>
            {prizeDescription &&
            <div className={style.col}>
                <div className={`${style.prize} ${isNoPrize ? style.isNoPrize : ''}`}>
                    {prizeDescription}
                </div>
            </div>
            }
        </div>
    </>
);

export const HeadRow = ({ showPrizes, isEventBased }) => {
    const t = usePortletTranslations();

    return (
        <div
            className={`${style.row} ${style.head} ${showPrizes ? '' : style.noPrizeCol} ${isEventBased && !showPrizes ? style.hasEventCol : ''}`}>
            <div className={style.col}>{t('competitorsTable.head.rank')}</div>
            <div className={style.col}>{t('competitorsTable.head.nickname')}</div>
            {!showPrizes && isEventBased && <div className={style.col}>{t('competitorsTable.head.events')}</div>}
            <div className={style.col}>{t('competitorsTable.head.score')}</div>
            {showPrizes && <div className={style.col}>{t('competitorsTable.head.prize')}</div>}
        </div>
    );
};

export const isEventBased = competitorsTable => competitorsTable.map(({ remainingEventCount }) => typeof remainingEventCount != 'undefined').indexOf(true) > -1;

export const trimNickNames = (competitorsTable) => {
    for (let i = 0; i < competitorsTable.length; i++) {
        if (competitorsTable[i].nickName) {
            if (competitorsTable[i].nickName.length > 12) {
                competitorsTable[i].nickName = `${competitorsTable[i].name.substr(0, 12)}...`;
            }
        }
    }
};

export const getMaxScoreLength = (competitorsTable) => {
    let biggestLength = 0;
    competitorsTable.map(({ score }) => {
        if (score.toString().length > biggestLength) {
            biggestLength = score.toString().length;
        }
        return score;
    });
    return biggestLength;
};

export const getScoreFontSize = (maxLength, eventBased) => {
    if (maxLength <= 5) {
        if (eventBased) {
            return 'mediumScore';
        }
        return 'largeScore';
    }
    if (maxLength >= 12) {
        if (eventBased) {
            return 'tinyScore';
        }
        return 'verySmallScore';
    }
    if (maxLength >= 9) {
        if (eventBased) {
            return 'verySmallScore';
        }
        return 'smallScore';
    }
    if (maxLength >= 6) {
        if (eventBased) {
            return 'smallScore';
        }
        return 'mediumScore';
    }
};

export default ({ competitorsTable, showPrizes, status }) => {
    trimNickNames(competitorsTable);
    const scoreStyle = getScoreFontSize(getMaxScoreLength(competitorsTable), isEventBased(competitorsTable));
    let updatedCompetitorsTable = competitorsTable;
    if (status === 'PENDING_REVIEW') {
        updatedCompetitorsTable = updatedCompetitorsTable.map((row) => {
            row.isMe = false;

            return row;
        });
    }
    const t = useTranslations();

    return (
        <div>
            {
                status === 'PENDING_REVIEW' && (
                    <div className={style.textOverlay}>
                        {t('playtech.mobile.system.pass-the-parcel.notification.pendingLeaderboard')}
                    </div>
                )
            }
            <div className={`${style.table} ${style[status]}`}>
                <HeadRow showPrizes={showPrizes} isEventBased={isEventBased(updatedCompetitorsTable)} />
                {showPrizes ?
                    updatedCompetitorsTable
                        .map(({ rank, name, nickName, score, isMe, addDivider, prizeDescription }) => (
                            <Row
                                key={rank}
                                isNoPrize={!prizeDescription}
                                prizeDescription={prizeDescription || '-'}
                                isMarkRank={rank <= 3 && Boolean(prizeDescription)}
                                scoreStyle={scoreStyle}
                                {...{ name, nickName, rank, score, isMe, addDivider }}
                            />
                        ))
                    :
                    updatedCompetitorsTable.map(({
                                                     rank,
                                                     name,
                                                     nickName,
                                                     score,
                                                     isMe,
                                                     addDivider,
                                                     remainingEventCount
                                                 }) => (
                        <Row
                            key={rank}
                            isNoPrize={false}
                            isMarkRank={rank <= 3}
                            scoreStyle={scoreStyle}
                            {...{ name, nickName, rank, score, isMe, addDivider, remainingEventCount }}
                        />
                    ))}
            </div>
        </div>
    );
};
